/* eslint-disable */

const customDropdown = {
  init() {
    const dropdowns = document.querySelectorAll('.sk-custom-dropdown');

    if (!dropdowns.length) {
      return;
    }

    dropdowns.forEach((dropdown) => {
      this.initDropdown(dropdown);
    });

    // Close all dropdowns on outside click
    document.addEventListener('click', (event) => {
      if (event.target.closest('.sk-custom-dropdown')) {
        return;
      }

      dropdowns.forEach((dropdown) => {
        this.closeDropdown(dropdown);
      });
    });

    // Close the focused dropdown on Escape
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      const openDropdown = document.querySelector('.sk-custom-dropdown.is-open');

      if (openDropdown) {
        const toggle = openDropdown.querySelector('.sk-custom-dropdown__toggle');
        this.closeDropdown(openDropdown);
        toggle && toggle.focus();
      }
    });
  },

  initDropdown(dropdown) {
    const toggle = dropdown.querySelector('.sk-custom-dropdown__toggle');
    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');

    if (!toggle) {
      return;
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      document
        .querySelectorAll('.sk-custom-dropdown.is-open')
        .forEach((openedDropdown) => {
          if (openedDropdown !== dropdown) {
            this.closeDropdown(openedDropdown);
          }
        });

      const willOpen = !dropdown.classList.contains('is-open');

      dropdown.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', willOpen);

      if (willOpen) {
        // Focus first option when dropdown opens
        const firstOption = dropdown.querySelector('.sk-custom-dropdown__option');
        firstOption && firstOption.focus();
      }
    });

    // Keyboard navigation inside dropdown
    dropdown.addEventListener('keydown', (event) => {
      if (!dropdown.classList.contains('is-open')) {
        return;
      }

      const options = Array.from(dropdown.querySelectorAll('.sk-custom-dropdown__option'));

      if (!options.length) {
        return;
      }

      const activeEl = document.activeElement;
      const currentIndex = options.indexOf(activeEl);

      switch (event.key) {
        case 'ArrowDown': {
          event.preventDefault();
          const nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          options[nextIndex].focus();
          break;
        }

        case 'ArrowUp': {
          event.preventDefault();
          const prevIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          options[prevIndex].focus();
          break;
        }

        case 'Home': {
          event.preventDefault();
          options[0].focus();
          break;
        }

        case 'End': {
          event.preventDefault();
          options[options.length - 1].focus();
          break;
        }

        case ' ':
        case 'Enter': {
          // Activate the focused label's checkbox
          if (activeEl && options.includes(activeEl)) {
            event.preventDefault();
            const checkbox = activeEl.querySelector('input[type="checkbox"]');
            if (checkbox) {
              checkbox.checked = !checkbox.checked;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          break;
        }

        case 'Tab': {
          // Close the dropdown when tabbing out
          event.preventDefault();
          this.closeDropdown(dropdown);
          toggle.focus();
          break;
        }
      }
    });

    // Update aria-selected when checkbox changes
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        const label = checkbox.closest('.sk-custom-dropdown__option');
        if (label) {
          label.setAttribute('aria-selected', checkbox.checked);
        }
        this.updateButtonText(dropdown);
      });
    });

    this.updateButtonText(dropdown);
  },

  updateButtonText(dropdown) {
    const toggle = dropdown.querySelector('.sk-custom-dropdown__toggle');

    if (!toggle) {
      return;
    }

    const defaultLabel = dropdown.dataset.label || 'Select';
    const checkedCheckboxes = dropdown.querySelectorAll('input[type="checkbox"]:checked');
    const count = checkedCheckboxes.length;

    toggle.textContent = count ? `${defaultLabel} (${count})` : defaultLabel;
  },

  closeDropdown(dropdown) {
    const toggle = dropdown.querySelector('.sk-custom-dropdown__toggle');

    dropdown.classList.remove('is-open');

    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    }
  },
};

export default customDropdown;
